import { useContext, useEffect, useRef, useState } from 'react'
import { SocketContext } from '../../../context/provider/SocketProvider';
import { notify } from '../../../utils/utils';

export const BotonNotificaciones = () => {
    const [ mostrar, setMostrar ] = useState(false);
    const [ opcion, setOpcion ] = useState(true);
    const [ numIcono, setNumIcono ] = useState(0);
    const [ mostrarIcono, setMostrarIcono ] = useState(false);
    const contenedorRef = useRef(null);
    const botonRef = useRef(null);
    const { stateSocket } = useContext(SocketContext)

    useEffect(()=> {
        console.log('payload',stateSocket.payload)
        if(Object.keys(stateSocket.payload).length > 0){
            if(stateSocket.payload.message){
                notify(stateSocket.payload.message.bd.mensaje, 'info');
                setNumIcono(i => i +1)
            }
        }
    },[stateSocket.payload])

    useEffect(() => {
        setMostrarIcono(mostrar)
    },[mostrar])

    const mostrarOcultarContenido = (event) =>{
        if (!contenedorRef?.current?.contains(event.relatedTarget)) {
            setMostrar(false);
        }
    }

    return (
        <>
            {/* <div className=''> */}
                <button
                    ref={botonRef}
                    className='hover:bg-blue-600 px-2 rounded lg:px-1 lg:py-0'
                    onClick={()=> {
                        setMostrar(!mostrar)
                        setMostrarIcono(false)
                    }}
                    onBlur={mostrarOcultarContenido}
                >
                    <i className='fa fa-bell'></i>
                    {
                        !mostrarIcono && numIcono > 0 &&
                        <>
                            <span
                                className='rounded-[50%] bg-[#ff5370] absolute text-center 
                                -top-1 -right-2 w-[22px] h-[22px] p-1 inline-block text-xs font-semibold'
                            >{numIcono}</span>
                        </>
                    }
                </button>
                {
                    mostrar &&
                    <div
                        ref={contenedorRef}
                        className={`top-[40px] w-[300px] h-[400px] z-50 bg-gray-800 rounded-xl
                        gap-2 overflow-hidden transition-all duration-1000 ease-out absolute right-[25%] `}
                    >
                        <section
                            className='w-full p-2 flex gap-3 justify-center border-b
                            h-[15%] border-gray-600'
                        >
                            <button
                                className={`${opcion ? ' bg-blue-800 ' : 'hover:bg-blue-600 ' }
                                p-1 rounded w-[80px] text-xs transition-all duration-500 ease-out`}
                                onClick={() => setOpcion(true)}
                            >No leidos</button>
                            <button
                                className={`${!opcion ? ' bg-blue-800 ' : 'hover:bg-blue-600 ' }
                                p-1 rounded w-[80px] text-xs transition-all duration-500 ease-out`}
                                onClick={() => setOpcion(false)}
                            >Leidos</button>
                        </section>
                        <section className='p-2 h-[70%]'>
                            <ul className='py-1 text-sm text-white '>
                                <li className='pb-1 border-gray-700 border-b'>
                                    <a className='notificacion' href='#.'>
                                        <i className='fa fa-bus pr-2 text-red-700'></i>
                                        <span className='font-semibold'>Rapido - 2411</span>
                                        <p>Reportó una nueva incidencia</p>
                                        <time>09/09/2024 11:40</time>
                                    </a>
                                </li>
                                <li className='pb-1 border-gray-700 border-b'>
                                    <a className='notificacion' href='#.' >
                                        <i className='fa fa-bus pr-2 text-red-700'></i>
                                        <span className='font-semibold'>Rapido - 2411</span>
                                        <p>Reportó una nueva incidencia</p>
                                        <time>09/09/2024 11:30</time>
                                    </a>
                                </li>
                            </ul>
                        </section>
                        <section
                            className='h-[15%] flex items-center justify-center
                            p-2 cursor-pointer border-gray-600 border-t'
                        >Ver más...</section>
                    </div>
                }
            {/* </div> */}
        </>
    )
}
























